import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8.5 18.5L12 22L15.5 18.5L14.793 17.793L12.5 20.086V2H11.5V20.086L9.207 17.793L8.5 18.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinLongDown"
);
